cb.define([], function () {
  var RM_rm_retailvouchlist_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		viewmodel.get('btnAdd').setVisible(false);
		let gridModel = viewmodel.getGridModel();
		gridModel.on('afterSetDataSource', () => {
			const rows = gridModel.getRows();
      const actions = gridModel.getCache('actions');
      if (!actions) return;
			const actionsStates = [];
			rows.forEach(data => {
				const actionState = { };
				actions.forEach(action => {
					actionState[action.cItemName] = { visible: true };
					if (data.fbitSettle) {
						actionState["btnEdit"] = { visible: false };
					}

				  });
				actionsStates.push(actionState);
			});
			gridModel.setActionsState(actionsStates);
		});

	  	gridModel.on('beforeLoad', function (data){
			var common = data.condition.commonVOs;
			data.isDistinct = true;
			if(common != undefined && common.length > 0)
			{
				var datas = [];
				common.forEach(function(item){
					if(!((item.itemName == "iNegative" && item.value1 == "-1") || (item.itemName == "iDeliveryState" && item.value1 == "-1")))
					{
						datas.push(item);
					}
	 			});
				data.condition.commonVOs = datas;
			}
		});
    },

  }
  try {
    module.exports = RM_rm_retailvouchlist_VM_Extend;
  } catch (error) {

  }
  return RM_rm_retailvouchlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_retailvouchlist_VM.Extend.js